import { motion } from "framer-motion";
import { PROBLEMS } from "@/data/content";
import { SectionEyebrow } from "@/components/Marquee";

export default function Problem() {
  return (
    <section id="problem" className="relative py-20 md:py-28 bg-void" data-testid="problem-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <SectionEyebrow n="Ch. VIII" testId="problem-eyebrow">
          The Manifesto
        </SectionEyebrow>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.8, 0, 0.2, 1] }}
          className="mt-6 font-serif text-white text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl"
          data-testid="problem-headline"
        >
          The car buying game is <span className="italic gradient-text">rigged.</span>
          <br /> Here's why.
        </motion.h2>

        <div className="mt-12 md:mt-16 grid gap-6 md:grid-cols-2">
          {PROBLEMS.map((p, i) => (
            <motion.article
              key={p.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: [0.8, 0, 0.2, 1] }}
              className="relative rounded-3xl border border-white/5 bg-surface p-8 md:p-10 overflow-hidden group"
              data-testid={`problem-card-${p.n}`}
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(circle at 30% 20%, rgba(139,92,246,0.18), transparent 55%)",
                }}
              />
              <div className="relative flex items-start gap-6">
                <div className="font-serif text-4xl md:text-5xl text-white/25">{p.n}</div>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl text-white leading-tight">{p.title}</h3>
                  <p className="mt-4 text-silver/70 leading-relaxed">{p.body}</p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
